import { render, staticRenderFns } from "./CustomersAtRisk.vue?vue&type=template&id=f39d6c4c&scoped=true&"
import script from "./CustomersAtRisk.vue?vue&type=script&lang=js&"
export * from "./CustomersAtRisk.vue?vue&type=script&lang=js&"
import style0 from "./CustomersAtRisk.vue?vue&type=style&index=0&id=f39d6c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39d6c4c",
  null
  
)

export default component.exports